import React from 'react'
import styled from 'styled-components'
import { vc_base, vc_color } from '../../assets/js/Brand'

// components
import Caption from '../atoms/BaseCaption'
import Anchor from '../atoms/BaseAnchor'

// template
const Breadcrumb = (props) => (
  <BreadcrumbTag>
    <BreadcrumbInner>
      <BreadcrumbList>
        <Anchor to="/">
          <Caption type={'span'}>トップ</Caption>
        </Anchor>
      </BreadcrumbList>

      {props.breadcrumb
        ? props.breadcrumb.map((crumb) => {
            return (
              <BreadcrumbList key={crumb.id}>
                <Anchor to={crumb.link}>
                  <Caption type={'span'}>{crumb.name}</Caption>
                </Anchor>
              </BreadcrumbList>
            )
          })
        : ''}

      {props.current ? (
        <BreadcrumbList>
          <Caption type={'span'}>{props.current}</Caption>
        </BreadcrumbList>
      ) : (
        ''
      )}
    </BreadcrumbInner>
  </BreadcrumbTag>
)

export default Breadcrumb

// style
const BreadcrumbTag = styled.div`
  height: 1.65em;
  margin-bottom: ${vc_base.pixel`1.5`};
  overflow: hidden;
  width: 100%;
`
const BreadcrumbInner = styled.ul`
  align-items: center;
  display: flex;
  overflow: auto;
  padding-bottom: 2em;
`
const BreadcrumbList = styled.li`
  padding-left: 1.5em;
  padding-right: 0.5em;
  position: relative;
  white-space: nowrap;
  z-index: 1;
  &::before {
    border-right: 1px solid ${vc_color.text_gray};
    border-top: 1px solid ${vc_color.text_gray};
    content: '';
    display: inline-block;
    height: 0.65em;
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    width: 0.65em;
    z-index: 1;
  }
  &:first-child {
    padding-left: 0;
    &::before {
      display: none;
    }
  }
`
